var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagNo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 32 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "flag-no_svg__a",
  width: 32,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v24H0z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#flag-no_svg__a)"
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E31D1C",
  fillRule: "evenodd",
  d: "M0 0v24h32V0z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "flag-no_svg__b",
  width: 32,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 0v24h32V0z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#flag-no_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2E42A5",
  stroke: "#F7FCFF",
  strokeWidth: 2,
  d: "M15-1V9h18v6H15v10H9V15H-1V9H9V-1z"
})))));
export default SvgFlagNo;